import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addStaff } from 'slices/staffSlice';
import { staffSelector } from 'slices/staffSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/staffSlice';
import toast from 'react-hot-toast';
import { updateStaff } from 'slices/staffSlice';
import { fetchStaff } from 'slices/staffSlice';
import { Button, Spinner } from 'reactstrap';
import Api from "services/api"
import { CustomSwitch } from 'components/common/Switch';
import { fetchCitys } from 'slices/citySlice';
import { fetchStates } from 'slices/stateSlice';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import CustomMultiSelect from 'components/common/CustomMultiSelect';
import { languageSelector } from 'slices/languageSlice';
import { typesSelector } from 'slices/typeSlice';
import { fetchLanguages } from 'slices/languageSlice';
import PhoneInput from 'components/common/PhoneInput';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';

const apiService = new Api();
const AddStaffForm = ({ item, handleClose, callback, show, statusPerm }) => {
  const dispatch = useDispatch()
  const { getValues, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const [loadingCities, setLoadingCities] = React.useState(false);
  const { language: languages } = useSelector(languageSelector);
  const { loader, error } = useSelector(staffSelector);
  const { types } = useSelector(typesSelector);


  useEffect(() => {

    // dispatch(fetchLanguages(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }))
  }, []);

  const resetFields = () => {

    setValue('first_name', '');
    setValue('type', '');
    setValue('last_name', '');
    setValue('email', '');
    setValue("phone", '');
    setValue('status', 1)
    setValue("language_ids", [])
    setValue("password", '');
    setLanguageState([]);
  }

  useEffect(() => {
    setValue('first_name', item?.first_name || '')
    setValue('last_name', item?.last_name || '');
    setValue('type', item?.type || '')
    setValue('email', item?.user?.email || '');
    setValue('phone', item?.phone || '')
    setValue('gender', item?.gender || '');
    setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
    setValue('language_ids', item?.languages?.map(language => language.id) || [])
    dispatch(setError({}))

    return () => resetFields()


  }, [item])

  useEffect(() => {
    !show && resetFields();
    return () => resetFields()
  }, [show])

  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      handleClose();
      dispatch(fetchStaff())
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    if (item?.id) {
      dispatch(updateStaff(data, item?.id, submitCallback));
    } else
      dispatch(addStaff(data, submitCallback));

  }

  const typeOptions = [
    { value: 'agent', label: 'Agent' },
    { value: 'interpreter', label: 'Interpreter' },
    { value: 'remote-operator', label: 'Remote Operator' },
  ]
  const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'nonbinary', label: 'Nonbinary' },
  ]


  // const filteredLanguages = React.useMemo(() =>
  //   languages?.map(language => {
  //     const object = {
  //       value: language.id,
  //       label: language.name
  //     }
  //     return object
  //   }), [languages]);

  // #region Language dropdown
  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    setLanguageState(
      item?.languages?.map(val => ({
        label: val?.language?.name || "",
        value: val?.language?.id || ""
      }))
    );
  }, [item?.languages]);


  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>


        <div className="row-primary">
          <h2>Type *</h2>
          <Controller
            name="type"
            control={control}
            rules={{
              required: "Please select a type"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="type"
                  options={typeOptions || []}
                  onChange={(value) => {
                    field.onChange(value);
                    if (value === "interpreter") setValue("password", "")
                  }}
                  value={field.value ? typeOptions?.find((opt) => field.value == opt.value) : ""}


                />
                {
                  errors?.type?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.type?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>First Name *</h2>
          <Controller
            name="first_name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='first_name' placeholder='First Name' required {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Last Name</h2>
          <Controller
            name="last_name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='last_name' placeholder='Last Name' {...field} />}
          />
        </div>

        <div className="row-primary">
          <h2>Email *</h2>
          <Controller
            name="email"
            control={control}
            rules={{
              required: true,
            }}

            render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email'
              required
              pattern={
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
              }
              placeholder="Email Address"
              {...field} />}
          />
        </div>


        <div className="row-primary">
          <h2>Password {(item?.id || watch("type") == "interpreter") ? "" : "*"}</h2>
          <Controller
            name="password"
            control={control}
            render={({ field }) =>
              <input className={`input-in type_inp `} type="password" name='password' required={item?.id ? false : true} placeholder="Password" {...field}
                disabled={watch("type") == "interpreter" ? true : false}
              />}
          />
        </div>

        <div className="row-primary">
          <h2>Phone</h2>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""} `}
              type="tel" name='contact' placeholder='Phone number' required {...field} />
            }
          />
        </div>

        <div className="row-primary">
          <h2>Gender *</h2>
          <Controller
            name="gender"
            control={control}
            rules={{
              required: "Please select a gender"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="gender"
                  options={genderOptions || []}
                  {...field}
                  value={field.value ? genderOptions?.find((opt) => field.value == opt.value) : ""}

                />
                {
                  errors?.gender?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.gender?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>


        <div className="row-primary">
          <h2>Select Languages *</h2>
          <Controller
            name="language_ids"
            required
            rules={{
              required: "Languages must be specified",
            }}
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='bottom'
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected)
                      field.onChange(selected.map((opt) => opt.value))
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.language_ids?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.language_ids?.message} />
                </div>}
              </div>
            }
          />
        </div>

        {statusPerm &&
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <Controller
              name="status"
              control={control}
              required
              rules={{
                required: true
              }}
              render={({ field }) => (
                <CustomSwitch
                  labelText={field.value == 1 ? "Active" : "Inactive"}
                  checked={field.value}
                  handleChange={(checked) => field.onChange(checked ? 1 : 0)}

                />
              )}
            />
          </div>
        }

        {error?.errors?.phone?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}


        {error?.errors?.email?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" className="main_button">

            {loader ?
              <>
                <Spinner size="sm">
                  Loading...
                </Spinner>

                <span>
                  {' '}Loading
                </span>
              </>
              :
              <span>
                {item?.id ? "Update" : "Create"}
              </span>
            }
          </button>
        </div>
      </form>

    </div>
  )
}

const AddStaff = ({ item, onClose, callback, show, statusPerm }) => {
  const closeButton = useRef(null)
  const refModal = useRef(null)
  const handleModalDismiss = () => {
    closeButton.current.click()
    onClose()
    // Perform any other actions on modal dismiss
  };
  useEffect(() => {


    const modalElement = refModal.current;

    if (modalElement) {
      // Attach the event listener
      modalElement.addEventListener("hidden.bs.modal", handleModalDismiss);
    }

    return () => {
      if (modalElement) {
        // Clean up the event listener
        modalElement.removeEventListener("hidden.bs.modal", handleModalDismiss);
      }
    };
  }, []);
  return (
    <div ref={refModal} className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Staff</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" ref={closeButton} aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddStaffForm item={item} handleClose={handleModalDismiss} callback={callback} show={show} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddStaff
